export default function Cookies() {
    return (
        <section className="py-10 px-10 text-sm min-h-[33.1vh]">
            <h1 className="font-semibold text-2xl">Cookie Policy</h1>
            <p>We respect your privacy and do not use cookies for tracking, advertising, or analytics. <strong>Tech4All</strong> is designed to work without collecting unnecessary browsing data.</p>
            <h2 className="font-semibold">What are cookies?</h2>
            <p className="text-xs">Cookies are small text files stored on your device that help us provide a better experience. We use cookies to remember your preferences and to track your activity on our website.</p>
        </section>
    )
}